export default {
  unReadNotificationForSys: (state) => {
    return state.countUnreadNotificationsForSys
  },
}
